var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('footer',{staticClass:"footer"},[_c('span',[_vm._v("Copyright "),_c('strong',[_vm._v(" ML 18 ")]),_vm._v(" © 2022-"+_vm._s(_vm.moment().format('YYYY'))+" ")])])}
var staticRenderFns = []

export { render, staticRenderFns }